module.exports = __webpack_public_path__ + "img/part4-3.c3dcc629.png";